import { Car } from 'lucide-react';
import InputField from './InputField';
import type { WizardDaten } from '@/lib/mietwagen-wizard-validation';

interface Props {
  daten: WizardDaten;
  onChange: (updated: Partial<WizardDaten>) => void;
}

export default function Step3Fahrzeuge({ daten, onChange }: Props) {
  const set = (field: keyof WizardDaten, value: unknown) => onChange({ [field]: value });

  return (
    <div className="space-y-5 p-5">
      <div className="flex items-center gap-2 mb-1">
        <Car className="w-4 h-4 text-orange-600" />
        <h3 className="text-sm font-semibold">Fahrzeuge</h3>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {/* Geschädigtes Fahrzeug */}
        <div className="p-4 bg-red-50 rounded-xl border border-red-100 space-y-3">
          <p className="text-[11px] font-bold text-red-700 uppercase tracking-wide">Geschädigtes Fahrzeug</p>
          <InputField required label="Kennzeichen" value={daten.geschaedigtes_kfz_kennzeichen} onChange={v => set('geschaedigtes_kfz_kennzeichen', v)} />
          <InputField label="Typ / Modell" value={daten.geschaedigtes_kfz_typ} onChange={v => set('geschaedigtes_kfz_typ', v)} />
          <InputField required label="Fahrzeugklasse" value={daten.geschaedigtes_kfz_klasse} onChange={v => set('geschaedigtes_kfz_klasse', v)} />
          <InputField label="FIN (optional)" value={daten.geschaedigtes_kfz_fin} onChange={v => set('geschaedigtes_kfz_fin', v)} placeholder="z. B. WVWZZZ1JZ3W386752" />
          <InputField label="HSN/TSN (optional)" value={daten.geschaedigtes_kfz_hsn_tsn} onChange={v => set('geschaedigtes_kfz_hsn_tsn', v)} placeholder="z. B. 0603 / AHX" />
        </div>

        {/* Mietfahrzeug */}
        <div className="p-4 bg-green-50 rounded-xl border border-green-100 space-y-3">
          <p className="text-[11px] font-bold text-green-700 uppercase tracking-wide">Mietfahrzeug</p>
          <InputField required label="Kennzeichen" value={daten.miet_kfz_kennzeichen} onChange={v => set('miet_kfz_kennzeichen', v)} />
          <InputField label="Typ / Modell" value={daten.miet_kfz_typ} onChange={v => set('miet_kfz_typ', v)} />
          <InputField required label="Fahrzeugklasse" value={daten.miet_kfz_klasse} onChange={v => set('miet_kfz_klasse', v)} />
          <InputField label="FIN (optional)" value={daten.miet_kfz_fin} onChange={v => set('miet_kfz_fin', v)} placeholder="z. B. WVWZZZ1JZ3W386752" />
          <InputField label="HSN/TSN (optional)" value={daten.miet_kfz_hsn_tsn} onChange={v => set('miet_kfz_hsn_tsn', v)} placeholder="z. B. 0603 / AHX" />
        </div>
      </div>
    </div>
  );
}
